<template>
  <div v-if="isMobile" class="share-body">
    <div class="share-top">
      <!-- <img src="@/assets/share-title.gif" /> -->
      <div class="banner-title">鸿合直播&nbsp;&nbsp;随时听课</div>
      <div class="banner-toast">
        记&nbsp;录&nbsp;精&nbsp;彩&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;播&nbsp;种&nbsp;未&nbsp;来
      </div>
    </div>

    <!-- 直播信息 -->
    <div class="share-bottom">
      <div class="top">
        <div class="live-info">
          <div class="live-title">{{ detail.liveTitle }}</div>
          <div class="live-number" style="margin-top:-28px">
            直播频道：{{ detail.streamCodeDevice }}
          </div>
          <div class="live-user">讲师：{{ detail.userName }}</div>
          <div class="live-date" style="margin-top:8px">开始时间：{{ detail.startTime }}</div>
          <div class="live-date-msg" style="margin-top:32px">
            (*在鸿合媒体中心的看直播中输入直播码可观看直播)
          </div>
        </div>
      </div>
      <!-- 二维码 -->
      <div class="miniprogram-code">
        <qrcode :value="shareUrl" :options="{ size: 170 }" />
      </div>
    </div>
  </div>
  <div v-else class="share-body-pc">
    <div class="share-top">
      <!-- <img src="@/assets/share-title.gif" /> -->
      <div class="banner-title">鸿合直播&nbsp;&nbsp;随时听课</div>
      <div class="banner-toast">
        记&nbsp;录&nbsp;精&nbsp;彩&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;播&nbsp;种&nbsp;未&nbsp;来
      </div>
    </div>

    <!-- 直播信息 -->
    <div class="share-bottom">
      <div class="top">
        <div class="live-info">
          <div class="live-title">{{ detail.liveTitle }}</div>
          <div class="live-number" style="margin-top:-148px">
            直播频道：{{ detail.streamCodeDevice }}
          </div>
          <div class="live-user">讲师：{{ detail.userName }}</div>
          <div class="live-date" style="margin-top:8px">开始时间：{{ detail.startTime }}</div>
          <div class="live-date-msg" style="margin-top:120px">
            (*在鸿合媒体中心的看直播中输入直播码可观看直播)
          </div>
        </div>
      </div>
      <!-- 二维码 -->
      <div class="miniprogram-code">
        <QrcodePC :value="shareUrl" :options="{ size: 170 }" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Qrcode from '@/components/Qrcode';
import QrcodePC from '@/components/Qrcode/indexPC';
import liveApi from '@/api/live';
import { isMobile } from '@/utils/index.js';

export default {
  name: 'live-share',
  components: {
    Qrcode,
    QrcodePC
  },
  data() {
    return {
      detail: '',
      mobile: '',
      isMobile: false
    };
  },
  computed: {
    ...mapGetters(['currentLive', 'userInfo']),
    shareUrl() {
      // const schoolName = encodeURI(this.detail.schoolName);
      // const url = `${window.location.origin}/Lives.html/liveShare/${
      //   this.detail.liveId
      // }/${schoolName}/${this.detail.streamStatus}/${this.mobile}`;
      // return url;
      const schoolName = encodeURI(this.$route.query.schoolName);
      const url = `${window.location.origin}/Lives.html/liveShare/${
        this.$route.query.liveId
      }/${schoolName}/${this.$route.query.streamStatus}/${this.mobile}`;
      return url;
    }
  },
  created() {
    this.isMobile = isMobile();
  },
  mounted() {
    this.mobile = this.$route.query.mobile;
    this.getLiveDetail();
    document.querySelector('.live-title').style.width = document.body.clientWidth - 68 + 'px';
  },
  methods: {
    back() {
      this.$router ? this.$router.back() : window.history.back();
    },
    getLiveDetail() {
      let schoolName = this.$route.query.schoolName;
      let liveId = this.$route.query.liveId;
      console.log('this.$route:', this.$route);
      const params = {
        liveId: liveId,
        schoolName: schoolName
      };
      liveApi.fetchLiveCodeDetail(params).then(response => {
        if (response.code === 0) {
          console.log('response.result666661111:', response.result);
          this.detail = response.result;
          document.title = this.detail.liveTitle
        }
      });
    },
    saveAsImage() {
      this.showActionSheet();
    },
    showActionSheet() {
      if (!this.saveActionSheet) {
        this.saveActionSheet = this.$createActionSheet({
          data: [
            {
              content: '保存图片到本地'
            }
          ],
          maskClosable: false,
          onSelect: (item, index) => {
            console.log('index: ', index);
            if (item.content === '保存图片到本地') {
              this.saveImage();
            }
          }
        });
      }
      this.saveActionSheet.show();
    },
    saveImage() {
      // const that = this;
      window.html2canvas(document.body).then(function(canvas) {
        const img = window.Canvas2Image.convertToPNG(canvas, 640, 960);
        const base64 = img.src.split(',')[1];
        if (this.$isIos()) {
          window.webkit.messageHandlers.CreturnImgbin.postMessage({ imgbin: base64 });
        } else {
          NativeApi.CreturnImgbin(base64);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.share-body {
  background: linear-gradient(to bottom right, white, #afd9ff);
  height: 820px;
  .share-top {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 130px;
    color: #1890ff;

    .banner-toast {
      font-size: 14px;
      margin-top: 16px;
    }

    img {
      width: 292px;
      height: 110px;
    }
  }

  .share-bottom {
    height: 450px;
    background: #fff;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    -moz-background-size: 100% 100%;
    // background-image: url('../../../assets/share-back.gif');
    background-image: url('../../../assets/share-back2.png');
    /* margin: 0 30rpx; */
    margin-top: 10px;
    margin-bottom: 10px;
    border-radius: 7px;
    .top {
      height: 120px;
      display: flex;
      margin: 0 10px;
      padding-top: 10px;
      position: relative;
      .live-info {
        position: absolute;
        left: 24px;
        top: 68px;
        // text-align: left;
        .live-title {
          /* display: block; */
          font-weight: bold;
          font-size: 18px;
          /* margin-left: -3.10973333rem; */
          text-align: left;
          margin-top: 8px;
          // height: 32px;
          line-height: 24px;
          margin-bottom: 40px;
          // white-space: nowrap;
          // text-overflow: ellipsis;
          // overflow: hidden;
        }
        .live-user {
          color: #666;
          /* margin-left: -3.00rem; */
          text-align: left;
          font-size: 14px;
        }
        .live-date {
          position: absolute;
          // left: 24px;
          // top: 140px;
          color: #666;
          // margin-top: 6px;
          text-align: left;
          font-size: 14px;
        }
        .live-number {
          font-weight: bold;
          position: absolute;
          // color: #1890FF;
          text-align: left;
          font-size: 14px;
        }
        .live-date-msg {
          position: absolute;
          // left: 24px;
          // top: 140px;
          color: #666;
          // margin-top: 6px;
          text-align: left;
          font-size: 10px;
        }
      }
      // .live-date {
      //   position: absolute;
      //   left: 24px;
      //   top: 140px;
      //   color: #666;
      //   // margin-top: 6px;
      //   text-align: left;
      //   font-size: 14px;
      // }
    }

    /* 二维码 */
    .miniprogram-code {
      text-align: left;
      margin-top: 100px;
      margin-left: 40px;
      img {
        width: 100px;
        height: 100px;
      }
    }
  }
}
.share-body-pc {
  background: linear-gradient(to bottom right, white, #afd9ff);
  height: 820px;
  .share-top {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    color: #1890ff;

    .banner-title, .banner-toast {
      font-size: 14px;
      margin-top: 2px;
    }

    img {
      width: 292px;
      height: 110px;
    }
  }

  .share-bottom {
    height: 450px;
    background: #fff;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    -moz-background-size: 100% 100%;
    // background-image: url('../../../assets/share-back.gif');
    background-image: url('../../../assets/share-back2.png');
    /* margin: 0 30rpx; */
    margin-top: 10px;
    margin-bottom: 10px;
    border-radius: 7px;
    .top {
      height: 120px;
      display: flex;
      margin: 0 10px;
      padding-top: 10px;
      position: relative;
      .live-info {
        position: absolute;
        left: 24px;
        top: 68px;
        // text-align: left;
        .live-title {
          /* display: block; */
          font-weight: bold;
          font-size: 18px;
          /* margin-left: -3.10973333rem; */
          text-align: left;
          margin-top: 8px;
          // height: 32px;
          line-height: 24px;
          margin-bottom: 40px;
          // white-space: nowrap;
          // text-overflow: ellipsis;
          // overflow: hidden;
        }
        .live-user {
          color: #666;
          /* margin-left: -3.00rem; */
          text-align: left;
          font-size: 14px;
        }
        .live-date {
          position: absolute;
          // left: 24px;
          // top: 140px;
          color: #666;
          // margin-top: 6px;
          text-align: left;
          font-size: 14px;
        }
        .live-number {
          font-weight: bold;
          position: absolute;
          // color: #1890FF;
          text-align: left;
          font-size: 14px;
        }
        .live-date-msg {
          position: absolute;
          // left: 24px;
          // top: 140px;
          color: #666;
          // margin-top: 6px;
          text-align: left;
          font-size: 10px;
        }
      }
      // .live-date {
      //   position: absolute;
      //   left: 24px;
      //   top: 140px;
      //   color: #666;
      //   // margin-top: 6px;
      //   text-align: left;
      //   font-size: 14px;
      // }
    }

    /* 二维码 */
    .miniprogram-code {
      text-align: left;
      margin-top: 100px;
      margin-left: 40px;
      img {
        width: 100px;
        height: 100px;
      }
    }
  }
}
</style>
